import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { Link } from '@reach/router'
import useCallbackStatus from 'hooks/useCallbackStatus'
import { StringParam, useQueryParams } from 'use-query-params'
import { Form } from 'antd'
import { StyledAlert } from 'components'
import {
	StyledPreLoginForm,
	PreLoginView,
	StyledPreLoginAlert,
	PreLoginTitle,
	PreLoginSubTitle,
	PreLoginInputPassword,
	PreLoginButton,
	PreLoginViewFooter
} from 'views/PreLogin/styled'
import useAxios from 'axios-hooks'
import { UtesterLogo, User1stLogo } from '../Logos';

const PASSWORD = 'new_password'
const CONFIRM_PASSWORD = 'confirm_password'
const ResetPasswordForm = styled.div({
	marginTop: 20
})

function ResetPassword({ form }) {
	const { isPending, error, run } = useCallbackStatus()
	const { getFieldDecorator } = form
	const [token] = useQueryParams({
		token: StringParam
	})

	const [
		{ data: passwordRecoveryResponse, loading: passwordRecoveryLoading, error: passwordRecoveryError, response },
		submitPasswordRecovery
	] = useAxios(
		{
			url: `/account/reset-password`,
			method: 'POST'
		},
		{ manual: true }
	)

	const validateConfirmPassword = (rule, value, callback) => {
		if (value && value !== form.getFieldValue(PASSWORD)) {
			callback('Password confirmation must be same as password');
		}

		callback();
	};

	const handleSubmit = event => {
		event.preventDefault()
		form.validateFields([PASSWORD, CONFIRM_PASSWORD], (errors, values) => {
			const { new_password } = values
			
			if (!errors) {
				submitPasswordRecovery({ data: {password: new_password, token: token.token} })
			}
		})
	}

	const errorMessage =
		passwordRecoveryError &&
		passwordRecoveryError.response &&
		passwordRecoveryError.response.data &&
		passwordRecoveryError.response.data.Errors.join('/n')

	const successMessage = response 
			&& response.status == 200
			&& (
				<div>Password has been changed. Please, use <a href="/sign-in">sign-in</a> page to login.</div>
			)

	successMessage && form.resetFields()
	return (
		<PreLoginView>
			<StyledPreLoginForm>
				<UtesterLogo />
				{errorMessage && (
					<StyledPreLoginAlert>
						<StyledAlert showIcon type="error" message="Error" description={errorMessage} radius={4} />
					</StyledPreLoginAlert>
				)}
				{successMessage && (
					<StyledPreLoginAlert>
						<StyledAlert showIcon type="success" message="Success" description={successMessage} radius={4} />
					</StyledPreLoginAlert>
				)}
				<PreLoginTitle>Reset Password</PreLoginTitle>
				<PreLoginSubTitle>Enter your new password and confirm it.</PreLoginSubTitle>
				<ResetPasswordForm>
					<Form onSubmit={handleSubmit} layout="vertical">
						<Form.Item>
							{getFieldDecorator(PASSWORD, {
								validateTrigger: ['onChange', 'onBlur'],
								rules: [
									{
										required: true,
										message: 'Password is Required'
									}
								]
							})(<PreLoginInputPassword type="password" placeholder="PASSWORD" />)}
						</Form.Item>
						
						<Form.Item>
							{getFieldDecorator(CONFIRM_PASSWORD, {
								validateTrigger: ['onChange', 'onBlur'],
								rules: [
									{
										required: true,
										message: 'Password must be confirmed'
									},
									{
										validator: validateConfirmPassword
									}
								]
							})(<PreLoginInputPassword type="password" placeholder="CONFIRM PASSWORD" />)}
						</Form.Item>

						<PreLoginButton size="large" type="primary" htmlType="submit" loading={isPending}>
							RESET PASSWORD
						</PreLoginButton>
					</Form>
				</ResetPasswordForm>
				<PreLoginViewFooter>
					<a href="/sign-in">Go back to sign-in</a>
				</PreLoginViewFooter>
			</StyledPreLoginForm>
			<User1stLogo />
		</PreLoginView>
	)
}
export default Form.create({})(ResetPassword)
